import { ImpactType, ImpactShopSortOption } from "@ecologi/shared";

export const ALL_CATEGORIES_VALUE = "ALL_CATEGORIES" as const;
export const ALL_CARBON_VALUE = "ALL_CARBON" as const;
export const ALL_LOCATIONS_VALUE = "ALL_LOCATIONS" as const;
export const ALL_LOCATIONS_LABEL = "All locations" as const;
export const IMPACT_FUND_VALUE = "IMPACT_FUND" as const;

export type CategoryFilterValue =
  | ImpactType
  | "ALL_CATEGORIES"
  | "ALL_CARBON"
  | "IMPACT_FUND";

type CategoryOption = { value: CategoryFilterValue; label: string };
type SortOption = { value: ImpactShopSortOption; label: string };

export const IMPACT_CATEGORY_OPTIONS: CategoryOption[] = [
  { value: ALL_CATEGORIES_VALUE, label: "All project categories" },
  { value: ImpactType.TREES, label: "Reforestation" },
  { value: ALL_CARBON_VALUE, label: "All carbon projects" },
  { value: ImpactType.CARBON_OFFSETS, label: "Carbon avoidance" },
  { value: ImpactType.CARBON_REMOVAL, label: "Carbon removal" },
  { value: ImpactType.HABITAT_RESTORATION, label: "Habitat restoration" },
  { value: IMPACT_FUND_VALUE, label: "Impact funds" },
] as const;

export const SORT_OPTIONS: SortOption[] = [
  { value: ImpactShopSortOption.RECOMMENDED, label: "Recommended" },
  { value: ImpactShopSortOption.NEWEST, label: "Newest" },
  { value: ImpactShopSortOption.PRICE_LOW_HIGH, label: "Price: low to high" },
  { value: ImpactShopSortOption.PRICE_HIGH_LOW, label: "Price: high to low" },
] as const;
